export default {

    // -------------------addStoreForm----------------------
    // 检查是否为空
    checkEmpty : function (rule, value, callback) {
        setTimeout(() => {
            // console.log(value);
            if(value==""||value==undefined){
                callback(new Error('不能为空'));
            }else{
                callback();
            }
        }, 500);
    },
    // 检车账户名长度
    checklength : function (rule,value,callback){
        var login_name = $.trim(value);
        var istrue = /^.{1,6}$/;  
        var error = "不能超过6个字符";  
        // 如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback(new Error('名称不能为空'));
        }else{
            if(istrue.exec(login_name)){
                callback();
                return false; 
            }else{
                callback(new Error(error));
                return false;  
            }
        }
    },
    // 检验门店账号
    checklogin_name : function (rule,value,callback){
        var login_name = $.trim(value);
        var istrue = /^[a-zA-Z][a-zA-Z0-9]{2,15}$/;  
        var error = "请输入英文开头的3至16个字符";  
        // 如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback(new Error('账号不能为空'));
        }else{
            if(istrue.exec(login_name)){
                callback();
                return false; 
            }else{
                callback(new Error(error));
                return false;  
            }
        }
    },
    //检验门店密码
    checklogin_pass : function (rule,value,callback){
        var login_name = $.trim(value);
        var istrue = /^[a-zA-Z0-9]{6,16}$/;  
        var error = "请输入6至16位英文数字密码";  
        // 如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback(new Error('密码不能为空'));
        }else{
            if(istrue.exec(login_name)){
                callback();
                return false; 
            }else{
                callback(new Error(error));
                return false;  
            }
        }
    },
    // 检查是否选择日期或者选择永久
    checkdate : function (rule,value, callback) {
        setTimeout(() => {
            // console.log(typeof value);
            if(value==""||value==undefined){
                callback(new Error('请选择日期或者永久'));
            }else{
                callback();
            }
        }, 500);
    },
    // 检查是否是正整数
    checkPlusNumber : function (rule, value, callback) {
        if (!value) {
            return callback(new Error('不能为空'));
        }
        setTimeout(() => {
            value = Number(value);
            if (!Number.isInteger(value)) {
                callback(new Error('请输入正整数'));
            } else {
                if (value < 0) {
                    callback(new Error('大于0正整数'));
                } else {
                    callback();
                }
            }
        }, 500);
    },
    // 验证电话号码
    checkContactNumber : function(rule, value, callback){   
        var mobile = $.trim(value);
        var isMobile = /^1[0-9]{10}$/;  
        var isPhone = /^0\d{2,3}-?\d{7,8}$/;
        var error = "请正确填写电话号码，例如:13511111111或010-11111111";  
        //如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback(new Error('号码不能为空'));
        }else{
            if (mobile.substring(0, 1) == 1) {  
                if (isMobile.exec(mobile)&&mobile.length==11) {  
                    callback();
                    return false;  
                }else{
                    callback(new Error(error));
                    return false;  
                }  
            }else if (mobile.substring(0, 1) == 0) {  
                if (isPhone.test(mobile)) {  
                    callback();
                    return false;  
                }else{
                    callback(new Error(error));
                    return false;  
                }    
            }else{
                callback(new Error(error));
            }  
        }
        
    },
    //验证不是必填的电话号码
    checkphoneNumber : function(rule, value, callback){   
        var mobile = $.trim(value);
        var isMobile = /^1[0-9]{10}$/;  
        var isPhone = /^0\d{2,3}-?\d{7,8}$/;
        var error = "请正确填写电话号码，例如:13511111111或010-11111111";  
        //如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback();
        }else{
            if (mobile.substring(0, 1) == 1) {  
                if (isMobile.exec(mobile)&&mobile.length==11) {  
                    callback();
                    return false;  
                }else{
                    callback(new Error(error));
                    return false;  
                }  
            }else if (mobile.substring(0, 1) == 0) {  
                if (isPhone.test(mobile)) {  
                    callback();
                    return false;  
                }else{
                    callback(new Error(error));
                    return false;  
                }    
            }else{
                callback(new Error(error));
            }  
        }
        
    },
     //检验数字
     check_number: function (rule,value,callback){
        var login_name = $.trim(value);
        var istrue = /^[0-9\-0-9]{1,20}$/;  
        var error = "请输入正确的号码";  
        // 如果为1开头则验证手机号码 
        if(value==""||value==undefined){
            callback();
            return false;  
        }else{
            if(istrue.exec(login_name)){
                callback();
                return false; 
            }else{
                callback(new Error(error));
                return false;  
            }
        }
    },
    // 检查是否是0-1440
    checkNumberOne: function (rule, value, callback) {
        var myvalue = $.trim(value);
        // console.log(myvalue)
        var isnumber = /^[1-9]\d*$/;
        if (value == "" || value == undefined || null) {
            return callback(new Error('不能为空'));
        } else if (value == 0) {
            callback();
            return false;
        } else {
            if (isnumber.test(myvalue)) {
                if (myvalue <= 1440) {
                    callback();
                    return false;
                } else {
                    callback(new Error('请输入0-1440的整数'));
                    return false;
                }
            } else {
                callback(new Error('请输入0-1440的整数'));
                return false;
            }
        }
    },
    // 检查是否是1-1440
    checkNumberTwo: function (rule, value, callback) {
        var myvalue = $.trim(value);
        // console.log(myvalue)
        var isnumber = /^[1-9]\d*$/;
        if (value == "" || value == undefined || null) {
            return callback(new Error('不能为空'));
        } else {
            if (isnumber.test(myvalue)) {
                if (myvalue <= 1440) {
                    callback();
                    return false;
                } else {
                    callback(new Error('请输入1-1440的整数'));
                    return false;
                }
            } else {
                callback(new Error('请输入1-1440的整数'));
                return false;
            }
        }
    },
    // 检查房间名称长度
    checkroomlength: function (rule, value, callback) {
        var login_name = $.trim(value);
        var t =login_name.replace(/[\u4e00-\u9fa5]/g,'');//替换中文
        var km=(login_name.length-t.length)*2+t.length;//判断长度
        // console.log(t)
        // console.log(km)
        var istrue = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
        var error = "不超过12个字节的英文数字或汉字";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('名称不能为空'));
        } else {
            if (istrue.exec(login_name)&&km<=12) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    },
    // -------------------addStoreForm----------------------
}



// WEBPACK FOOTER //
// ./src/common_js/formCheck.js